import { Authority } from '@/shared/security/authority';
/* tslint:disable */
// prettier-ignore
const Entities = () => import('@/entities/entities.vue');

const ServiceInstance = () => import('@/entities/service-instance/service-instance.vue');
const ServiceInstanceUpdate = () => import('@/entities/service-instance/service-instance-update.vue');
const ServiceInstanceDetails = () => import('@/entities/service-instance/service-instance-details.vue');

const ServiceSpecification = () => import('@/entities/service-specification/service-specification.vue');
const ServiceSpecificationUpdate = () => import('@/entities/service-specification/service-specification-update.vue');
const ServiceSpecificationDetails = () => import('@/entities/service-specification/service-specification-details.vue');

const ServiceTechnicalDesign = () => import('@/entities/service-technical-design/service-technical-design.vue');
const ServiceTechnicalDesignUpdate = () => import('@/entities/service-technical-design/service-technical-design-update.vue');
const ServiceTechnicalDesignDetails = () => import('@/entities/service-technical-design/service-technical-design-details.vue');

const AuthorInfo = () => import('@/entities/author-info/author-info.vue');
const AuthorInfoUpdate = () => import('@/entities/author-info/author-info-update.vue');
const AuthorInfoDetails = () => import('@/entities/author-info/author-info-details.vue');

const DataModelDescription = () => import('@/entities/data-model-description/data-model-description.vue');
const DataModelDescriptionUpdate = () => import('@/entities/data-model-description/data-model-description-update.vue');
const DataModelDescriptionDetails = () => import('@/entities/data-model-description/data-model-description-details.vue');

const ServiceInterface = () => import('@/entities/service-interface/service-interface.vue');
const ServiceInterfaceUpdate = () => import('@/entities/service-interface/service-interface-update.vue');
const ServiceInterfaceDetails = () => import('@/entities/service-interface/service-interface-details.vue');

const ServiceOperation = () => import('@/entities/service-operation/service-operation.vue');
const ServiceOperationUpdate = () => import('@/entities/service-operation/service-operation-update.vue');
const ServiceOperationDetails = () => import('@/entities/service-operation/service-operation-details.vue');

const Message = () => import('@/entities/message/message.vue');
const MessageUpdate = () => import('@/entities/message/message-update.vue');
const MessageDetails = () => import('@/entities/message/message-details.vue');

const Technology = () => import('@/entities/technology/technology.vue');
const TechnologyUpdate = () => import('@/entities/technology/technology-update.vue');
const TechnologyDetails = () => import('@/entities/technology/technology-details.vue');

const Endpoint = () => import('@/entities/endpoint/endpoint.vue');
const EndpointUpdate = () => import('@/entities/endpoint/endpoint-update.vue');
const EndpointDetails = () => import('@/entities/endpoint/endpoint-details.vue');

const CoverageArea = () => import('@/entities/coverage-area/coverage-area.vue');
const CoverageAreaUpdate = () => import('@/entities/coverage-area/coverage-area-update.vue');
const CoverageAreaDetails = () => import('@/entities/coverage-area/coverage-area-details.vue');

const SwsrInformationService = () => import('@/entities/swsr-information-service/swsr-information-service.vue');
const SwsrInformationServiceUpdate = () => import('@/entities/swsr-information-service/swsr-information-service-update.vue');
const SwsrInformationServiceDetails = () => import('@/entities/swsr-information-service/swsr-information-service-details.vue');

const SwsrServiceProvision = () => import('@/entities/swsr-service-provision/swsr-service-provision.vue');
const SwsrServiceProvisionUpdate = () => import('@/entities/swsr-service-provision/swsr-service-provision-update.vue');
const SwsrServiceProvisionDetails = () => import('@/entities/swsr-service-provision/swsr-service-provision-details.vue');

const SwsrPointOfContact = () => import('@/entities/swsr-point-of-contact/swsr-point-of-contact.vue');
const SwsrPointOfContactUpdate = () => import('@/entities/swsr-point-of-contact/swsr-point-of-contact-update.vue');
const SwsrPointOfContactDetails = () => import('@/entities/swsr-point-of-contact/swsr-point-of-contact-details.vue');

const SwsrDescriptionInformation = () => import('@/entities/swsr-description-information/swsr-description-information.vue');
const SwsrDescriptionInformationUpdate = () => import('@/entities/swsr-description-information/swsr-description-information-update.vue');
const SwsrDescriptionInformationDetails = () => import('@/entities/swsr-description-information/swsr-description-information-details.vue');

const SwsrServiceDescription = () => import('@/entities/swsr-service-description/swsr-service-description.vue');
const SwsrServiceDescriptionUpdate = () => import('@/entities/swsr-service-description/swsr-service-description-update.vue');
const SwsrServiceDescriptionDetails = () => import('@/entities/swsr-service-description/swsr-service-description-details.vue');

const SwsrAbbreviation = () => import('@/entities/swsr-abbreviation/swsr-abbreviation.vue');
const SwsrAbbreviationUpdate = () => import('@/entities/swsr-abbreviation/swsr-abbreviation-update.vue');
const SwsrAbbreviationDetails = () => import('@/entities/swsr-abbreviation/swsr-abbreviation-details.vue');

const SwsrServiceCategorisation = () => import('@/entities/swsr-service-categorisation/swsr-service-categorisation.vue');
const SwsrServiceCategorisationUpdate = () => import('@/entities/swsr-service-categorisation/swsr-service-categorisation-update.vue');
const SwsrServiceCategorisationDetails = () => import('@/entities/swsr-service-categorisation/swsr-service-categorisation-details.vue');

const CodeApplicationMessageExchangePatternTypeWrapper = () =>
  import('@/entities/code-application-message-exchange-pattern-type-wrapper/code-application-message-exchange-pattern-type-wrapper.vue');
const CodeApplicationMessageExchangePatternTypeWrapperUpdate = () =>
  import(
    '@/entities/code-application-message-exchange-pattern-type-wrapper/code-application-message-exchange-pattern-type-wrapper-update.vue'
  );
const CodeApplicationMessageExchangePatternTypeWrapperDetails = () =>
  import(
    '@/entities/code-application-message-exchange-pattern-type-wrapper/code-application-message-exchange-pattern-type-wrapper-details.vue'
  );

const CodeBusinessActivityTypeWrapper = () =>
  import('@/entities/code-business-activity-type-wrapper/code-business-activity-type-wrapper.vue');
const CodeBusinessActivityTypeWrapperUpdate = () =>
  import('@/entities/code-business-activity-type-wrapper/code-business-activity-type-wrapper-update.vue');
const CodeBusinessActivityTypeWrapperDetails = () =>
  import('@/entities/code-business-activity-type-wrapper/code-business-activity-type-wrapper-details.vue');

const CodeInformationExchangeCategoryWrapper = () =>
  import('@/entities/code-information-exchange-category-wrapper/code-information-exchange-category-wrapper.vue');
const CodeInformationExchangeCategoryWrapperUpdate = () =>
  import('@/entities/code-information-exchange-category-wrapper/code-information-exchange-category-wrapper-update.vue');
const CodeInformationExchangeCategoryWrapperDetails = () =>
  import('@/entities/code-information-exchange-category-wrapper/code-information-exchange-category-wrapper-details.vue');

const CodeStakeholderTypeWrapper = () => import('@/entities/code-stakeholder-type-wrapper/code-stakeholder-type-wrapper.vue');
const CodeStakeholderTypeWrapperUpdate = () => import('@/entities/code-stakeholder-type-wrapper/code-stakeholder-type-wrapper-update.vue');
const CodeStakeholderTypeWrapperDetails = () =>
  import('@/entities/code-stakeholder-type-wrapper/code-stakeholder-type-wrapper-details.vue');

const SwsrGeographicalExtent = () => import('@/entities/swsr-geographical-extent/swsr-geographical-extent.vue');
const SwsrGeographicalExtentUpdate = () => import('@/entities/swsr-geographical-extent/swsr-geographical-extent-update.vue');
const SwsrGeographicalExtentDetails = () => import('@/entities/swsr-geographical-extent/swsr-geographical-extent-details.vue');

const AerodromeIcaoLocationIndicator = () => import('@/entities/aerodrome-icao-location-indicator/aerodrome-icao-location-indicator.vue');
const AerodromeIcaoLocationIndicatorUpdate = () =>
  import('@/entities/aerodrome-icao-location-indicator/aerodrome-icao-location-indicator-update.vue');
const AerodromeIcaoLocationIndicatorDetails = () =>
  import('@/entities/aerodrome-icao-location-indicator/aerodrome-icao-location-indicator-details.vue');

const FirIcaoLocationIndicator = () => import('@/entities/fir-icao-location-indicator/fir-icao-location-indicator.vue');
const FirIcaoLocationIndicatorUpdate = () => import('@/entities/fir-icao-location-indicator/fir-icao-location-indicator-update.vue');
const FirIcaoLocationIndicatorDetails = () => import('@/entities/fir-icao-location-indicator/fir-icao-location-indicator-details.vue');

const StateIcaoNationalityLetters = () => import('@/entities/state-icao-nationality-letters/state-icao-nationality-letters.vue');
const StateIcaoNationalityLettersUpdate = () =>
  import('@/entities/state-icao-nationality-letters/state-icao-nationality-letters-update.vue');
const StateIcaoNationalityLettersDetails = () =>
  import('@/entities/state-icao-nationality-letters/state-icao-nationality-letters-details.vue');

const SwsrServiceDescriptionReferences = () =>
  import('@/entities/swsr-service-description-references/swsr-service-description-references.vue');
const SwsrServiceDescriptionReferencesUpdate = () =>
  import('@/entities/swsr-service-description-references/swsr-service-description-references-update.vue');
const SwsrServiceDescriptionReferencesDetails = () =>
  import('@/entities/swsr-service-description-references/swsr-service-description-references-details.vue');

const SwsrImplementedStandard = () => import('@/entities/swsr-implemented-standard/swsr-implemented-standard.vue');
const SwsrImplementedStandardUpdate = () => import('@/entities/swsr-implemented-standard/swsr-implemented-standard-update.vue');
const SwsrImplementedStandardDetails = () => import('@/entities/swsr-implemented-standard/swsr-implemented-standard-details.vue');

const SwsrDocument = () => import('@/entities/swsr-document/swsr-document.vue');
const SwsrDocumentUpdate = () => import('@/entities/swsr-document/swsr-document-update.vue');
const SwsrDocumentDetails = () => import('@/entities/swsr-document/swsr-document-details.vue');

const SwsrServiceTechnicalDescription = () =>
  import('@/entities/swsr-service-technical-description/swsr-service-technical-description.vue');
const SwsrServiceTechnicalDescriptionUpdate = () =>
  import('@/entities/swsr-service-technical-description/swsr-service-technical-description-update.vue');
const SwsrServiceTechnicalDescriptionDetails = () =>
  import('@/entities/swsr-service-technical-description/swsr-service-technical-description-details.vue');

const SwsrSecurityMechanism = () => import('@/entities/swsr-security-mechanism/swsr-security-mechanism.vue');
const SwsrSecurityMechanismUpdate = () => import('@/entities/swsr-security-mechanism/swsr-security-mechanism-update.vue');
const SwsrSecurityMechanismDetails = () => import('@/entities/swsr-security-mechanism/swsr-security-mechanism-details.vue');

const CodeSecurityMechanismTypeWrapper = () =>
  import('@/entities/code-security-mechanism-type-wrapper/code-security-mechanism-type-wrapper.vue');
const CodeSecurityMechanismTypeWrapperUpdate = () =>
  import('@/entities/code-security-mechanism-type-wrapper/code-security-mechanism-type-wrapper-update.vue');
const CodeSecurityMechanismTypeWrapperDetails = () =>
  import('@/entities/code-security-mechanism-type-wrapper/code-security-mechanism-type-wrapper-details.vue');

const SwsrServiceMonitoring = () => import('@/entities/swsr-service-monitoring/swsr-service-monitoring.vue');
const SwsrServiceMonitoringUpdate = () => import('@/entities/swsr-service-monitoring/swsr-service-monitoring-update.vue');
const SwsrServiceMonitoringDetails = () => import('@/entities/swsr-service-monitoring/swsr-service-monitoring-details.vue');

const SwsrTechnicalConstraint = () => import('@/entities/swsr-technical-constraint/swsr-technical-constraint.vue');
const SwsrTechnicalConstraintUpdate = () => import('@/entities/swsr-technical-constraint/swsr-technical-constraint-update.vue');
const SwsrTechnicalConstraintDetails = () => import('@/entities/swsr-technical-constraint/swsr-technical-constraint-details.vue');

const SwsrInterface = () => import('@/entities/swsr-interface/swsr-interface.vue');
const SwsrInterfaceUpdate = () => import('@/entities/swsr-interface/swsr-interface-update.vue');
const SwsrInterfaceDetails = () => import('@/entities/swsr-interface/swsr-interface-details.vue');

const SwsrServiceBehaviour = () => import('@/entities/swsr-service-behaviour/swsr-service-behaviour.vue');
const SwsrServiceBehaviourUpdate = () => import('@/entities/swsr-service-behaviour/swsr-service-behaviour-update.vue');
const SwsrServiceBehaviourDetails = () => import('@/entities/swsr-service-behaviour/swsr-service-behaviour-details.vue');

const SwsrOperation = () => import('@/entities/swsr-operation/swsr-operation.vue');
const SwsrOperationUpdate = () => import('@/entities/swsr-operation/swsr-operation-update.vue');
const SwsrOperationDetails = () => import('@/entities/swsr-operation/swsr-operation-details.vue');

const TiProtocolMethodWrapper = () => import('@/entities/ti-protocol-method-wrapper/ti-protocol-method-wrapper.vue');
const TiProtocolMethodWrapperUpdate = () => import('@/entities/ti-protocol-method-wrapper/ti-protocol-method-wrapper-update.vue');
const TiProtocolMethodWrapperDetails = () => import('@/entities/ti-protocol-method-wrapper/ti-protocol-method-wrapper-details.vue');

const SwsrProcessingConsideration = () => import('@/entities/swsr-processing-consideration/swsr-processing-consideration.vue');
const SwsrProcessingConsiderationUpdate = () => import('@/entities/swsr-processing-consideration/swsr-processing-consideration-update.vue');
const SwsrProcessingConsiderationDetails = () =>
  import('@/entities/swsr-processing-consideration/swsr-processing-consideration-details.vue');

const SwsrMessage = () => import('@/entities/swsr-message/swsr-message.vue');
const SwsrMessageUpdate = () => import('@/entities/swsr-message/swsr-message-update.vue');
const SwsrMessageDetails = () => import('@/entities/swsr-message/swsr-message-details.vue');

const SwsrEndPoint = () => import('@/entities/swsr-end-point/swsr-end-point.vue');
const SwsrEndPointUpdate = () => import('@/entities/swsr-end-point/swsr-end-point-update.vue');
const SwsrEndPointDetails = () => import('@/entities/swsr-end-point/swsr-end-point-details.vue');

const SwsrResource = () => import('@/entities/swsr-resource/swsr-resource.vue');
const SwsrResourceUpdate = () => import('@/entities/swsr-resource/swsr-resource-update.vue');
const SwsrResourceDetails = () => import('@/entities/swsr-resource/swsr-resource-details.vue');

const SwsrServiceInformationDescription = () =>
  import('@/entities/swsr-service-information-description/swsr-service-information-description.vue');
const SwsrServiceInformationDescriptionUpdate = () =>
  import('@/entities/swsr-service-information-description/swsr-service-information-description-update.vue');
const SwsrServiceInformationDescriptionDetails = () =>
  import('@/entities/swsr-service-information-description/swsr-service-information-description-details.vue');

const SwsrInformationDefinition = () => import('@/entities/swsr-information-definition/swsr-information-definition.vue');
const SwsrInformationDefinitionUpdate = () => import('@/entities/swsr-information-definition/swsr-information-definition-update.vue');
const SwsrInformationDefinitionDetails = () => import('@/entities/swsr-information-definition/swsr-information-definition-details.vue');

const SwsrExchangeSchema = () => import('@/entities/swsr-exchange-schema/swsr-exchange-schema.vue');
const SwsrExchangeSchemaUpdate = () => import('@/entities/swsr-exchange-schema/swsr-exchange-schema-update.vue');
const SwsrExchangeSchemaDetails = () => import('@/entities/swsr-exchange-schema/swsr-exchange-schema-details.vue');

const SwsrServiceGeneralDescription = () => import('@/entities/swsr-service-general-description/swsr-service-general-description.vue');
const SwsrServiceGeneralDescriptionUpdate = () =>
  import('@/entities/swsr-service-general-description/swsr-service-general-description-update.vue');
const SwsrServiceGeneralDescriptionDetails = () =>
  import('@/entities/swsr-service-general-description/swsr-service-general-description-details.vue');

const SwsrQualityOfService = () => import('@/entities/swsr-quality-of-service/swsr-quality-of-service.vue');
const SwsrQualityOfServiceUpdate = () => import('@/entities/swsr-quality-of-service/swsr-quality-of-service-update.vue');
const SwsrQualityOfServiceDetails = () => import('@/entities/swsr-quality-of-service/swsr-quality-of-service-details.vue');

const SwsrOperationalNeed = () => import('@/entities/swsr-operational-need/swsr-operational-need.vue');
const SwsrOperationalNeedUpdate = () => import('@/entities/swsr-operational-need/swsr-operational-need-update.vue');
const SwsrOperationalNeedDetails = () => import('@/entities/swsr-operational-need/swsr-operational-need-details.vue');

const SwsrValidationOfService = () => import('@/entities/swsr-validation-of-service/swsr-validation-of-service.vue');
const SwsrValidationOfServiceUpdate = () => import('@/entities/swsr-validation-of-service/swsr-validation-of-service-update.vue');
const SwsrValidationOfServiceDetails = () => import('@/entities/swsr-validation-of-service/swsr-validation-of-service-details.vue');

const SwsrFunctionality = () => import('@/entities/swsr-functionality/swsr-functionality.vue');
const SwsrFunctionalityUpdate = () => import('@/entities/swsr-functionality/swsr-functionality-update.vue');
const SwsrFunctionalityDetails = () => import('@/entities/swsr-functionality/swsr-functionality-details.vue');

const SwsrConcept = () => import('@/entities/swsr-concept/swsr-concept.vue');
const SwsrConceptUpdate = () => import('@/entities/swsr-concept/swsr-concept-update.vue');
const SwsrConceptDetails = () => import('@/entities/swsr-concept/swsr-concept-details.vue');

const SwsrAccessAndUseCondition = () => import('@/entities/swsr-access-and-use-condition/swsr-access-and-use-condition.vue');
const SwsrAccessAndUseConditionUpdate = () => import('@/entities/swsr-access-and-use-condition/swsr-access-and-use-condition-update.vue');
const SwsrAccessAndUseConditionDetails = () => import('@/entities/swsr-access-and-use-condition/swsr-access-and-use-condition-details.vue');

const ContactDetails = () => import('@/entities/contact-details/contact-details.vue');
const ContactDetailsUpdate = () => import('@/entities/contact-details/contact-details-update.vue');
const ContactDetailsDetails = () => import('@/entities/contact-details/contact-details-details.vue');

const Email = () => import('@/entities/email/email.vue');
const EmailUpdate = () => import('@/entities/email/email-update.vue');
const EmailDetails = () => import('@/entities/email/email-details.vue');

const Phone = () => import('@/entities/phone/phone.vue');
const PhoneUpdate = () => import('@/entities/phone/phone-update.vue');
const PhoneDetails = () => import('@/entities/phone/phone-details.vue');

const Comment = () => import('@/entities/comment/comment.vue');
const CommentUpdate = () => import('@/entities/comment/comment-update.vue');
const CommentDetails = () => import('@/entities/comment/comment-details.vue');

// jhipster-needle-add-entity-to-router-import - JHipster will import entities to the router here

export default {
  path: '/',
  component: Entities,
  children: [
    {
      path: 'service-instance',
      name: 'ServiceInstance',
      component: ServiceInstance,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'service-instance/new',
      name: 'ServiceInstanceCreate',
      component: ServiceInstanceUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'service-instance/:serviceInstanceId/edit',
      name: 'ServiceInstanceEdit',
      component: ServiceInstanceUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'service-instance/:serviceInstanceId/view',
      name: 'ServiceInstanceView',
      component: ServiceInstanceDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'service-specification',
      name: 'ServiceSpecification',
      component: ServiceSpecification,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'service-specification/new',
      name: 'ServiceSpecificationCreate',
      component: ServiceSpecificationUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'service-specification/:serviceSpecificationId/edit',
      name: 'ServiceSpecificationEdit',
      component: ServiceSpecificationUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'service-specification/:serviceSpecificationId/view',
      name: 'ServiceSpecificationView',
      component: ServiceSpecificationDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'service-technical-design',
      name: 'ServiceTechnicalDesign',
      component: ServiceTechnicalDesign,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'service-technical-design/new',
      name: 'ServiceTechnicalDesignCreate',
      component: ServiceTechnicalDesignUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'service-technical-design/:serviceTechnicalDesignId/edit',
      name: 'ServiceTechnicalDesignEdit',
      component: ServiceTechnicalDesignUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'service-technical-design/:serviceTechnicalDesignId/view',
      name: 'ServiceTechnicalDesignView',
      component: ServiceTechnicalDesignDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'author-info',
      name: 'AuthorInfo',
      component: AuthorInfo,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'author-info/new',
      name: 'AuthorInfoCreate',
      component: AuthorInfoUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'author-info/:authorInfoId/edit',
      name: 'AuthorInfoEdit',
      component: AuthorInfoUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'author-info/:authorInfoId/view',
      name: 'AuthorInfoView',
      component: AuthorInfoDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'data-model-description',
      name: 'DataModelDescription',
      component: DataModelDescription,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'data-model-description/new',
      name: 'DataModelDescriptionCreate',
      component: DataModelDescriptionUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'data-model-description/:dataModelDescriptionId/edit',
      name: 'DataModelDescriptionEdit',
      component: DataModelDescriptionUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'data-model-description/:dataModelDescriptionId/view',
      name: 'DataModelDescriptionView',
      component: DataModelDescriptionDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'service-interface',
      name: 'ServiceInterface',
      component: ServiceInterface,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'service-interface/new',
      name: 'ServiceInterfaceCreate',
      component: ServiceInterfaceUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'service-interface/:serviceInterfaceId/edit',
      name: 'ServiceInterfaceEdit',
      component: ServiceInterfaceUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'service-interface/:serviceInterfaceId/view',
      name: 'ServiceInterfaceView',
      component: ServiceInterfaceDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'service-operation',
      name: 'ServiceOperation',
      component: ServiceOperation,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'service-operation/new',
      name: 'ServiceOperationCreate',
      component: ServiceOperationUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'service-operation/:serviceOperationId/edit',
      name: 'ServiceOperationEdit',
      component: ServiceOperationUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'service-operation/:serviceOperationId/view',
      name: 'ServiceOperationView',
      component: ServiceOperationDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'message',
      name: 'Message',
      component: Message,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'message/new',
      name: 'MessageCreate',
      component: MessageUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'message/:messageId/edit',
      name: 'MessageEdit',
      component: MessageUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'message/:messageId/view',
      name: 'MessageView',
      component: MessageDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'technology',
      name: 'Technology',
      component: Technology,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'technology/new',
      name: 'TechnologyCreate',
      component: TechnologyUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'technology/:technologyId/edit',
      name: 'TechnologyEdit',
      component: TechnologyUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'technology/:technologyId/view',
      name: 'TechnologyView',
      component: TechnologyDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'endpoint',
      name: 'Endpoint',
      component: Endpoint,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'endpoint/new',
      name: 'EndpointCreate',
      component: EndpointUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'endpoint/:endpointId/edit',
      name: 'EndpointEdit',
      component: EndpointUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'endpoint/:endpointId/view',
      name: 'EndpointView',
      component: EndpointDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'coverage-area',
      name: 'CoverageArea',
      component: CoverageArea,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'coverage-area/new',
      name: 'CoverageAreaCreate',
      component: CoverageAreaUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'coverage-area/:coverageAreaId/edit',
      name: 'CoverageAreaEdit',
      component: CoverageAreaUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'coverage-area/:coverageAreaId/view',
      name: 'CoverageAreaView',
      component: CoverageAreaDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-information-service',
      name: 'SwsrInformationService',
      component: SwsrInformationService,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-information-service/new',
      name: 'SwsrInformationServiceCreate',
      component: SwsrInformationServiceUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-information-service/:swsrInformationServiceId/edit',
      name: 'SwsrInformationServiceEdit',
      component: SwsrInformationServiceUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-information-service/:swsrInformationServiceId/view',
      name: 'SwsrInformationServiceView',
      component: SwsrInformationServiceDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-service-provision',
      name: 'SwsrServiceProvision',
      component: SwsrServiceProvision,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-service-provision/new',
      name: 'SwsrServiceProvisionCreate',
      component: SwsrServiceProvisionUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-service-provision/:swsrServiceProvisionId/edit',
      name: 'SwsrServiceProvisionEdit',
      component: SwsrServiceProvisionUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-service-provision/:swsrServiceProvisionId/view',
      name: 'SwsrServiceProvisionView',
      component: SwsrServiceProvisionDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-point-of-contact',
      name: 'SwsrPointOfContact',
      component: SwsrPointOfContact,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-point-of-contact/new',
      name: 'SwsrPointOfContactCreate',
      component: SwsrPointOfContactUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-point-of-contact/:swsrPointOfContactId/edit',
      name: 'SwsrPointOfContactEdit',
      component: SwsrPointOfContactUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-point-of-contact/:swsrPointOfContactId/view',
      name: 'SwsrPointOfContactView',
      component: SwsrPointOfContactDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-description-information',
      name: 'SwsrDescriptionInformation',
      component: SwsrDescriptionInformation,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-description-information/new',
      name: 'SwsrDescriptionInformationCreate',
      component: SwsrDescriptionInformationUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-description-information/:swsrDescriptionInformationId/edit',
      name: 'SwsrDescriptionInformationEdit',
      component: SwsrDescriptionInformationUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-description-information/:swsrDescriptionInformationId/view',
      name: 'SwsrDescriptionInformationView',
      component: SwsrDescriptionInformationDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-service-description',
      name: 'SwsrServiceDescription',
      component: SwsrServiceDescription,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-service-description/new',
      name: 'SwsrServiceDescriptionCreate',
      component: SwsrServiceDescriptionUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-service-description/:swsrServiceDescriptionId/edit',
      name: 'SwsrServiceDescriptionEdit',
      component: SwsrServiceDescriptionUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-service-description/:swsrServiceDescriptionId/view',
      name: 'SwsrServiceDescriptionView',
      component: SwsrServiceDescriptionDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-abbreviation',
      name: 'SwsrAbbreviation',
      component: SwsrAbbreviation,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-abbreviation/new',
      name: 'SwsrAbbreviationCreate',
      component: SwsrAbbreviationUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-abbreviation/:swsrAbbreviationId/edit',
      name: 'SwsrAbbreviationEdit',
      component: SwsrAbbreviationUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-abbreviation/:swsrAbbreviationId/view',
      name: 'SwsrAbbreviationView',
      component: SwsrAbbreviationDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-service-categorisation',
      name: 'SwsrServiceCategorisation',
      component: SwsrServiceCategorisation,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-service-categorisation/new',
      name: 'SwsrServiceCategorisationCreate',
      component: SwsrServiceCategorisationUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-service-categorisation/:swsrServiceCategorisationId/edit',
      name: 'SwsrServiceCategorisationEdit',
      component: SwsrServiceCategorisationUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-service-categorisation/:swsrServiceCategorisationId/view',
      name: 'SwsrServiceCategorisationView',
      component: SwsrServiceCategorisationDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'code-application-message-exchange-pattern-type-wrapper',
      name: 'CodeApplicationMessageExchangePatternTypeWrapper',
      component: CodeApplicationMessageExchangePatternTypeWrapper,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'code-application-message-exchange-pattern-type-wrapper/new',
      name: 'CodeApplicationMessageExchangePatternTypeWrapperCreate',
      component: CodeApplicationMessageExchangePatternTypeWrapperUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'code-application-message-exchange-pattern-type-wrapper/:codeApplicationMessageExchangePatternTypeWrapperId/edit',
      name: 'CodeApplicationMessageExchangePatternTypeWrapperEdit',
      component: CodeApplicationMessageExchangePatternTypeWrapperUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'code-application-message-exchange-pattern-type-wrapper/:codeApplicationMessageExchangePatternTypeWrapperId/view',
      name: 'CodeApplicationMessageExchangePatternTypeWrapperView',
      component: CodeApplicationMessageExchangePatternTypeWrapperDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'code-business-activity-type-wrapper',
      name: 'CodeBusinessActivityTypeWrapper',
      component: CodeBusinessActivityTypeWrapper,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'code-business-activity-type-wrapper/new',
      name: 'CodeBusinessActivityTypeWrapperCreate',
      component: CodeBusinessActivityTypeWrapperUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'code-business-activity-type-wrapper/:codeBusinessActivityTypeWrapperId/edit',
      name: 'CodeBusinessActivityTypeWrapperEdit',
      component: CodeBusinessActivityTypeWrapperUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'code-business-activity-type-wrapper/:codeBusinessActivityTypeWrapperId/view',
      name: 'CodeBusinessActivityTypeWrapperView',
      component: CodeBusinessActivityTypeWrapperDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'code-information-exchange-category-wrapper',
      name: 'CodeInformationExchangeCategoryWrapper',
      component: CodeInformationExchangeCategoryWrapper,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'code-information-exchange-category-wrapper/new',
      name: 'CodeInformationExchangeCategoryWrapperCreate',
      component: CodeInformationExchangeCategoryWrapperUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'code-information-exchange-category-wrapper/:codeInformationExchangeCategoryWrapperId/edit',
      name: 'CodeInformationExchangeCategoryWrapperEdit',
      component: CodeInformationExchangeCategoryWrapperUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'code-information-exchange-category-wrapper/:codeInformationExchangeCategoryWrapperId/view',
      name: 'CodeInformationExchangeCategoryWrapperView',
      component: CodeInformationExchangeCategoryWrapperDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'code-stakeholder-type-wrapper',
      name: 'CodeStakeholderTypeWrapper',
      component: CodeStakeholderTypeWrapper,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'code-stakeholder-type-wrapper/new',
      name: 'CodeStakeholderTypeWrapperCreate',
      component: CodeStakeholderTypeWrapperUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'code-stakeholder-type-wrapper/:codeStakeholderTypeWrapperId/edit',
      name: 'CodeStakeholderTypeWrapperEdit',
      component: CodeStakeholderTypeWrapperUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'code-stakeholder-type-wrapper/:codeStakeholderTypeWrapperId/view',
      name: 'CodeStakeholderTypeWrapperView',
      component: CodeStakeholderTypeWrapperDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-geographical-extent',
      name: 'SwsrGeographicalExtent',
      component: SwsrGeographicalExtent,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-geographical-extent/new',
      name: 'SwsrGeographicalExtentCreate',
      component: SwsrGeographicalExtentUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-geographical-extent/:swsrGeographicalExtentId/edit',
      name: 'SwsrGeographicalExtentEdit',
      component: SwsrGeographicalExtentUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-geographical-extent/:swsrGeographicalExtentId/view',
      name: 'SwsrGeographicalExtentView',
      component: SwsrGeographicalExtentDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'aerodrome-icao-location-indicator',
      name: 'AerodromeIcaoLocationIndicator',
      component: AerodromeIcaoLocationIndicator,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'aerodrome-icao-location-indicator/new',
      name: 'AerodromeIcaoLocationIndicatorCreate',
      component: AerodromeIcaoLocationIndicatorUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'aerodrome-icao-location-indicator/:aerodromeIcaoLocationIndicatorId/edit',
      name: 'AerodromeIcaoLocationIndicatorEdit',
      component: AerodromeIcaoLocationIndicatorUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'aerodrome-icao-location-indicator/:aerodromeIcaoLocationIndicatorId/view',
      name: 'AerodromeIcaoLocationIndicatorView',
      component: AerodromeIcaoLocationIndicatorDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'fir-icao-location-indicator',
      name: 'FirIcaoLocationIndicator',
      component: FirIcaoLocationIndicator,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'fir-icao-location-indicator/new',
      name: 'FirIcaoLocationIndicatorCreate',
      component: FirIcaoLocationIndicatorUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'fir-icao-location-indicator/:firIcaoLocationIndicatorId/edit',
      name: 'FirIcaoLocationIndicatorEdit',
      component: FirIcaoLocationIndicatorUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'fir-icao-location-indicator/:firIcaoLocationIndicatorId/view',
      name: 'FirIcaoLocationIndicatorView',
      component: FirIcaoLocationIndicatorDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'state-icao-nationality-letters',
      name: 'StateIcaoNationalityLetters',
      component: StateIcaoNationalityLetters,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'state-icao-nationality-letters/new',
      name: 'StateIcaoNationalityLettersCreate',
      component: StateIcaoNationalityLettersUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'state-icao-nationality-letters/:stateIcaoNationalityLettersId/edit',
      name: 'StateIcaoNationalityLettersEdit',
      component: StateIcaoNationalityLettersUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'state-icao-nationality-letters/:stateIcaoNationalityLettersId/view',
      name: 'StateIcaoNationalityLettersView',
      component: StateIcaoNationalityLettersDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-service-description-references',
      name: 'SwsrServiceDescriptionReferences',
      component: SwsrServiceDescriptionReferences,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-service-description-references/new',
      name: 'SwsrServiceDescriptionReferencesCreate',
      component: SwsrServiceDescriptionReferencesUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-service-description-references/:swsrServiceDescriptionReferencesId/edit',
      name: 'SwsrServiceDescriptionReferencesEdit',
      component: SwsrServiceDescriptionReferencesUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-service-description-references/:swsrServiceDescriptionReferencesId/view',
      name: 'SwsrServiceDescriptionReferencesView',
      component: SwsrServiceDescriptionReferencesDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-implemented-standard',
      name: 'SwsrImplementedStandard',
      component: SwsrImplementedStandard,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-implemented-standard/new',
      name: 'SwsrImplementedStandardCreate',
      component: SwsrImplementedStandardUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-implemented-standard/:swsrImplementedStandardId/edit',
      name: 'SwsrImplementedStandardEdit',
      component: SwsrImplementedStandardUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-implemented-standard/:swsrImplementedStandardId/view',
      name: 'SwsrImplementedStandardView',
      component: SwsrImplementedStandardDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-document',
      name: 'SwsrDocument',
      component: SwsrDocument,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-document/new',
      name: 'SwsrDocumentCreate',
      component: SwsrDocumentUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-document/:swsrDocumentId/edit',
      name: 'SwsrDocumentEdit',
      component: SwsrDocumentUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-document/:swsrDocumentId/view',
      name: 'SwsrDocumentView',
      component: SwsrDocumentDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-service-technical-description',
      name: 'SwsrServiceTechnicalDescription',
      component: SwsrServiceTechnicalDescription,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-service-technical-description/new',
      name: 'SwsrServiceTechnicalDescriptionCreate',
      component: SwsrServiceTechnicalDescriptionUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-service-technical-description/:swsrServiceTechnicalDescriptionId/edit',
      name: 'SwsrServiceTechnicalDescriptionEdit',
      component: SwsrServiceTechnicalDescriptionUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-service-technical-description/:swsrServiceTechnicalDescriptionId/view',
      name: 'SwsrServiceTechnicalDescriptionView',
      component: SwsrServiceTechnicalDescriptionDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-security-mechanism',
      name: 'SwsrSecurityMechanism',
      component: SwsrSecurityMechanism,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-security-mechanism/new',
      name: 'SwsrSecurityMechanismCreate',
      component: SwsrSecurityMechanismUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-security-mechanism/:swsrSecurityMechanismId/edit',
      name: 'SwsrSecurityMechanismEdit',
      component: SwsrSecurityMechanismUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-security-mechanism/:swsrSecurityMechanismId/view',
      name: 'SwsrSecurityMechanismView',
      component: SwsrSecurityMechanismDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'code-security-mechanism-type-wrapper',
      name: 'CodeSecurityMechanismTypeWrapper',
      component: CodeSecurityMechanismTypeWrapper,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'code-security-mechanism-type-wrapper/new',
      name: 'CodeSecurityMechanismTypeWrapperCreate',
      component: CodeSecurityMechanismTypeWrapperUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'code-security-mechanism-type-wrapper/:codeSecurityMechanismTypeWrapperId/edit',
      name: 'CodeSecurityMechanismTypeWrapperEdit',
      component: CodeSecurityMechanismTypeWrapperUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'code-security-mechanism-type-wrapper/:codeSecurityMechanismTypeWrapperId/view',
      name: 'CodeSecurityMechanismTypeWrapperView',
      component: CodeSecurityMechanismTypeWrapperDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-service-monitoring',
      name: 'SwsrServiceMonitoring',
      component: SwsrServiceMonitoring,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-service-monitoring/new',
      name: 'SwsrServiceMonitoringCreate',
      component: SwsrServiceMonitoringUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-service-monitoring/:swsrServiceMonitoringId/edit',
      name: 'SwsrServiceMonitoringEdit',
      component: SwsrServiceMonitoringUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-service-monitoring/:swsrServiceMonitoringId/view',
      name: 'SwsrServiceMonitoringView',
      component: SwsrServiceMonitoringDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-technical-constraint',
      name: 'SwsrTechnicalConstraint',
      component: SwsrTechnicalConstraint,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-technical-constraint/new',
      name: 'SwsrTechnicalConstraintCreate',
      component: SwsrTechnicalConstraintUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-technical-constraint/:swsrTechnicalConstraintId/edit',
      name: 'SwsrTechnicalConstraintEdit',
      component: SwsrTechnicalConstraintUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-technical-constraint/:swsrTechnicalConstraintId/view',
      name: 'SwsrTechnicalConstraintView',
      component: SwsrTechnicalConstraintDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-interface',
      name: 'SwsrInterface',
      component: SwsrInterface,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-interface/new',
      name: 'SwsrInterfaceCreate',
      component: SwsrInterfaceUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-interface/:swsrInterfaceId/edit',
      name: 'SwsrInterfaceEdit',
      component: SwsrInterfaceUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-interface/:swsrInterfaceId/view',
      name: 'SwsrInterfaceView',
      component: SwsrInterfaceDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-service-behaviour',
      name: 'SwsrServiceBehaviour',
      component: SwsrServiceBehaviour,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-service-behaviour/new',
      name: 'SwsrServiceBehaviourCreate',
      component: SwsrServiceBehaviourUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-service-behaviour/:swsrServiceBehaviourId/edit',
      name: 'SwsrServiceBehaviourEdit',
      component: SwsrServiceBehaviourUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-service-behaviour/:swsrServiceBehaviourId/view',
      name: 'SwsrServiceBehaviourView',
      component: SwsrServiceBehaviourDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-operation',
      name: 'SwsrOperation',
      component: SwsrOperation,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-operation/new',
      name: 'SwsrOperationCreate',
      component: SwsrOperationUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-operation/:swsrOperationId/edit',
      name: 'SwsrOperationEdit',
      component: SwsrOperationUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-operation/:swsrOperationId/view',
      name: 'SwsrOperationView',
      component: SwsrOperationDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'ti-protocol-method-wrapper',
      name: 'TiProtocolMethodWrapper',
      component: TiProtocolMethodWrapper,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'ti-protocol-method-wrapper/new',
      name: 'TiProtocolMethodWrapperCreate',
      component: TiProtocolMethodWrapperUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'ti-protocol-method-wrapper/:tiProtocolMethodWrapperId/edit',
      name: 'TiProtocolMethodWrapperEdit',
      component: TiProtocolMethodWrapperUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'ti-protocol-method-wrapper/:tiProtocolMethodWrapperId/view',
      name: 'TiProtocolMethodWrapperView',
      component: TiProtocolMethodWrapperDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-processing-consideration',
      name: 'SwsrProcessingConsideration',
      component: SwsrProcessingConsideration,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-processing-consideration/new',
      name: 'SwsrProcessingConsiderationCreate',
      component: SwsrProcessingConsiderationUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-processing-consideration/:swsrProcessingConsiderationId/edit',
      name: 'SwsrProcessingConsiderationEdit',
      component: SwsrProcessingConsiderationUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-processing-consideration/:swsrProcessingConsiderationId/view',
      name: 'SwsrProcessingConsiderationView',
      component: SwsrProcessingConsiderationDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-message',
      name: 'SwsrMessage',
      component: SwsrMessage,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-message/new',
      name: 'SwsrMessageCreate',
      component: SwsrMessageUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-message/:swsrMessageId/edit',
      name: 'SwsrMessageEdit',
      component: SwsrMessageUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-message/:swsrMessageId/view',
      name: 'SwsrMessageView',
      component: SwsrMessageDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-end-point',
      name: 'SwsrEndPoint',
      component: SwsrEndPoint,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-end-point/new',
      name: 'SwsrEndPointCreate',
      component: SwsrEndPointUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-end-point/:swsrEndPointId/edit',
      name: 'SwsrEndPointEdit',
      component: SwsrEndPointUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-end-point/:swsrEndPointId/view',
      name: 'SwsrEndPointView',
      component: SwsrEndPointDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-resource',
      name: 'SwsrResource',
      component: SwsrResource,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-resource/new',
      name: 'SwsrResourceCreate',
      component: SwsrResourceUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-resource/:swsrResourceId/edit',
      name: 'SwsrResourceEdit',
      component: SwsrResourceUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-resource/:swsrResourceId/view',
      name: 'SwsrResourceView',
      component: SwsrResourceDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-service-information-description',
      name: 'SwsrServiceInformationDescription',
      component: SwsrServiceInformationDescription,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-service-information-description/new',
      name: 'SwsrServiceInformationDescriptionCreate',
      component: SwsrServiceInformationDescriptionUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-service-information-description/:swsrServiceInformationDescriptionId/edit',
      name: 'SwsrServiceInformationDescriptionEdit',
      component: SwsrServiceInformationDescriptionUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-service-information-description/:swsrServiceInformationDescriptionId/view',
      name: 'SwsrServiceInformationDescriptionView',
      component: SwsrServiceInformationDescriptionDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-information-definition',
      name: 'SwsrInformationDefinition',
      component: SwsrInformationDefinition,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-information-definition/new',
      name: 'SwsrInformationDefinitionCreate',
      component: SwsrInformationDefinitionUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-information-definition/:swsrInformationDefinitionId/edit',
      name: 'SwsrInformationDefinitionEdit',
      component: SwsrInformationDefinitionUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-information-definition/:swsrInformationDefinitionId/view',
      name: 'SwsrInformationDefinitionView',
      component: SwsrInformationDefinitionDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-exchange-schema',
      name: 'SwsrExchangeSchema',
      component: SwsrExchangeSchema,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-exchange-schema/new',
      name: 'SwsrExchangeSchemaCreate',
      component: SwsrExchangeSchemaUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-exchange-schema/:swsrExchangeSchemaId/edit',
      name: 'SwsrExchangeSchemaEdit',
      component: SwsrExchangeSchemaUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-exchange-schema/:swsrExchangeSchemaId/view',
      name: 'SwsrExchangeSchemaView',
      component: SwsrExchangeSchemaDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-service-general-description',
      name: 'SwsrServiceGeneralDescription',
      component: SwsrServiceGeneralDescription,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-service-general-description/new',
      name: 'SwsrServiceGeneralDescriptionCreate',
      component: SwsrServiceGeneralDescriptionUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-service-general-description/:swsrServiceGeneralDescriptionId/edit',
      name: 'SwsrServiceGeneralDescriptionEdit',
      component: SwsrServiceGeneralDescriptionUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-service-general-description/:swsrServiceGeneralDescriptionId/view',
      name: 'SwsrServiceGeneralDescriptionView',
      component: SwsrServiceGeneralDescriptionDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-quality-of-service',
      name: 'SwsrQualityOfService',
      component: SwsrQualityOfService,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-quality-of-service/new',
      name: 'SwsrQualityOfServiceCreate',
      component: SwsrQualityOfServiceUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-quality-of-service/:swsrQualityOfServiceId/edit',
      name: 'SwsrQualityOfServiceEdit',
      component: SwsrQualityOfServiceUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-quality-of-service/:swsrQualityOfServiceId/view',
      name: 'SwsrQualityOfServiceView',
      component: SwsrQualityOfServiceDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-operational-need',
      name: 'SwsrOperationalNeed',
      component: SwsrOperationalNeed,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-operational-need/new',
      name: 'SwsrOperationalNeedCreate',
      component: SwsrOperationalNeedUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-operational-need/:swsrOperationalNeedId/edit',
      name: 'SwsrOperationalNeedEdit',
      component: SwsrOperationalNeedUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-operational-need/:swsrOperationalNeedId/view',
      name: 'SwsrOperationalNeedView',
      component: SwsrOperationalNeedDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-validation-of-service',
      name: 'SwsrValidationOfService',
      component: SwsrValidationOfService,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-validation-of-service/new',
      name: 'SwsrValidationOfServiceCreate',
      component: SwsrValidationOfServiceUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-validation-of-service/:swsrValidationOfServiceId/edit',
      name: 'SwsrValidationOfServiceEdit',
      component: SwsrValidationOfServiceUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-validation-of-service/:swsrValidationOfServiceId/view',
      name: 'SwsrValidationOfServiceView',
      component: SwsrValidationOfServiceDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-functionality',
      name: 'SwsrFunctionality',
      component: SwsrFunctionality,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-functionality/new',
      name: 'SwsrFunctionalityCreate',
      component: SwsrFunctionalityUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-functionality/:swsrFunctionalityId/edit',
      name: 'SwsrFunctionalityEdit',
      component: SwsrFunctionalityUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-functionality/:swsrFunctionalityId/view',
      name: 'SwsrFunctionalityView',
      component: SwsrFunctionalityDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-concept',
      name: 'SwsrConcept',
      component: SwsrConcept,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-concept/new',
      name: 'SwsrConceptCreate',
      component: SwsrConceptUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-concept/:swsrConceptId/edit',
      name: 'SwsrConceptEdit',
      component: SwsrConceptUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-concept/:swsrConceptId/view',
      name: 'SwsrConceptView',
      component: SwsrConceptDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-access-and-use-condition',
      name: 'SwsrAccessAndUseCondition',
      component: SwsrAccessAndUseCondition,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-access-and-use-condition/new',
      name: 'SwsrAccessAndUseConditionCreate',
      component: SwsrAccessAndUseConditionUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-access-and-use-condition/:swsrAccessAndUseConditionId/edit',
      name: 'SwsrAccessAndUseConditionEdit',
      component: SwsrAccessAndUseConditionUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'swsr-access-and-use-condition/:swsrAccessAndUseConditionId/view',
      name: 'SwsrAccessAndUseConditionView',
      component: SwsrAccessAndUseConditionDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'contact-details',
      name: 'ContactDetails',
      component: ContactDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'contact-details/new',
      name: 'ContactDetailsCreate',
      component: ContactDetailsUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'contact-details/:contactDetailsId/edit',
      name: 'ContactDetailsEdit',
      component: ContactDetailsUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'contact-details/:contactDetailsId/view',
      name: 'ContactDetailsView',
      component: ContactDetailsDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'email',
      name: 'Email',
      component: Email,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'email/new',
      name: 'EmailCreate',
      component: EmailUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'email/:emailId/edit',
      name: 'EmailEdit',
      component: EmailUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'email/:emailId/view',
      name: 'EmailView',
      component: EmailDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'phone',
      name: 'Phone',
      component: Phone,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'phone/new',
      name: 'PhoneCreate',
      component: PhoneUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'phone/:phoneId/edit',
      name: 'PhoneEdit',
      component: PhoneUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'phone/:phoneId/view',
      name: 'PhoneView',
      component: PhoneDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'comment',
      name: 'Comment',
      component: Comment,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'comment/new',
      name: 'CommentCreate',
      component: CommentUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'comment/:commentId/edit',
      name: 'CommentEdit',
      component: CommentUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'comment/:commentId/view',
      name: 'CommentView',
      component: CommentDetails,
      meta: { authorities: [Authority.USER] },
    },
    // jhipster-needle-add-entity-to-router - JHipster will add entities to the router here
  ],
};
